import Header from "../../components/Header/LandingHeader";
import s from "./NewsDetails.module.scss";
import { useSelector } from "react-redux";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import PageTitle from "../../components/PageTitle/PageTitle";
import BackLink from "../../components/BackLink/BackLink";

const NewsDetails = () => {
  const news = useSelector((state) => state.landing.newsDetails);
  const { width } = useWindowDimensions();

  return (
    <div>
      {width > 1200 ? (
        <div className={s.header_wrapper}>
          <Header />
        </div>
      ) : (
        <MobileHeader />
      )}
      <div className={s.content}>
        <BackLink fallback="/news" className={s.back}>
          All news
        </BackLink>
        <div className={s.news_img}>
          <img src={news?.image} className={s.img} />
        </div>
        <PageTitle className={s.title} eyebrow="News" title={news?.title} />
        <div className={s.subtitle}>{news?.additional_title}</div>
        <div className={s.news_header}>
          <div className={s.category}>{news?.category?.name?.toUpperCase()}</div>
          <div className={s.date}>{news?.created_at}</div>
        </div>
        <div
          className={s.news_description}
          dangerouslySetInnerHTML={{ __html: news?.body }}
        ></div>
      </div>
      <LandingFooter />
    </div>
  );
};

export default NewsDetails;
